import React from "react"
import BlogListCategoriesStyle from "./BlogListCategoriesStyle.module.styl"
import { Link } from "gatsby"

const BlogListCategory = ({ category, path }) => {
  return (
    <React.Fragment>
      {category.node.contentfulparent ? null : path === "/blog" ? (
        <Link
          className={BlogListCategoriesStyle.category}
          to={`/${category.node.slug}/`}
        >
          {category.node.name}
        </Link>
      ) : (
        <Link
          className={
            path === `/${category.node.slug}/`
              ? BlogListCategoriesStyle.active_category
              : BlogListCategoriesStyle.category
          }
          to={`/${category.node.slug}/`}
        >
          {category.node.name}
        </Link>
      )}
      {category.node.categories &&
        category.node.categories.map((subCategory, index) => {
          return (
            <Link
              activeClassName={BlogListCategoriesStyle.active_subCategory}
              className={BlogListCategoriesStyle.subCategory}
              key={index}
              to={`/${subCategory.slug}/`}
            >
              {subCategory.name}
            </Link>
          )
        })}
    </React.Fragment>
  )
}

export default BlogListCategory
